import { policyList } from "@/enums/permissions";
import { EventBus, store } from "@/internal";
import { i18n } from "@/plugins/i18n";
import {
  ActionSubheader,
  TableAction,
  TableSuccessModalResponse
} from "helix-vue-components";
import { vendorService } from "./vendor.service";
class VendorActionService {
  public getGeneralActions(
    csvCallback: () => void,
    filtersCallback: () => void
  ): ActionSubheader[] {
    return [
      {
        icon: "fal fa-file-csv",
        action: csvCallback
      },
      {
        icon: "fal fa-plus",
        id: "btn_create_venlab",
        action: () => {
          store.dispatch("RouterModule/go", {
            name: "vendor-add"
          });
        },
        visibleCondition: () =>
          store.getters["PermissionsModule/hasPermission"](
            policyList.createVendorsLabs
          )
      },
      {
        icon: "fal fa-search",
        id: "btn_search_venlab",
        otherComponent: {
          name: "TableSearchComponent",
          action: vendorService.searchEvent()
        }
      },
      {
        icon: "fal fa-filter",
        action: filtersCallback
      }
    ];
  }

  public getRowActions(): TableAction[] {
    return [
      {
        icon: store.getters["PermissionsModule/hasPermission"](
          policyList.modifyVendorsLabs
        )
          ? "fal fa-pen"
          : "fal fa-eye",
        id: "btn_edit_venlab",
        action: (...arg: any[]) => {
          store.dispatch("RouterModule/go", {
            name: store.getters["PermissionsModule/hasPermission"](
              policyList.modifyVendorsLabs
            )
              ? "vendor-edit"
              : "vendor-view",
            params: {
              id: arg[0].id
            }
          });
        }
      },
      {
        icon: "",
        switch: "is_active",
        visibleCondition: () =>
          store.getters["PermissionsModule/hasPermission"](
            policyList.enableDisableVendorsLabs
          ),
        modalActions: {
          modalNumber: 1,
          modalQuestion: String(i18n.t("vendors.vendor_toggle_confirm")),
          modalSuccessText: String(i18n.t("yes")),
          modalSuccessAction: async (arg: TableSuccessModalResponse) => {
            try {
              await vendorService.toggleVendor(arg);
              store
                .dispatch("VendorModule/loadVendors")
                .finally(arg.unselectModal);
            } catch (e) {
              EventBus.$emit("unSelectedModalActive");
              arg.unselectModal();
            }
          },
          modalCancelText: String(i18n.t("no"))
        }
      }
    ];
  }

  public getMultiActions(): TableAction[] {
    return [
      {
        icon: "fal fa-eye",
        action(args: any) {
          store.dispatch("VendorModule/enableMultiple", args);
        },
        visibleCondition: () =>
          store.getters["PermissionsModule/hasPermission"](
            policyList.enableDisableVendorsLabs
          )
      },
      {
        icon: "fal fa-eye-slash",
        action(args: any) {
          store.dispatch("VendorModule/disableMultiple", args);
        },
        visibleCondition: () =>
          store.getters["PermissionsModule/hasPermission"](
            policyList.enableDisableVendorsLabs
          )
      }
    ];
  }
}

export const vendorActionService = new VendorActionService();
